/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncidenciaTecnicaModelDto } from '../../models/incidencia-tecnica-model-dto';

export interface IncidenciasTecnicasControllerEnviarIncidenciaTecnica$Params {
  
    /**
     * Datos de la incidencia técnica a enviar
     */
    body: IncidenciaTecnicaModelDto
}

export function incidenciasTecnicasControllerEnviarIncidenciaTecnica(http: HttpClient, rootUrl: string, params: IncidenciasTecnicasControllerEnviarIncidenciaTecnica$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, incidenciasTecnicasControllerEnviarIncidenciaTecnica.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

incidenciasTecnicasControllerEnviarIncidenciaTecnica.PATH = '/api/incidencias-tecnicas/enviar-incidencia-tecnica';
